import React, { createContext, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState(() => {
    try {
      const raw = localStorage.getItem("user");
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  });

  const login = async (token, userData) => {
    if (!token || !userData) return false;
    try {
      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(userData));
      // store a small tokenPayload object that other parts of the app expect



      try {
        const role = (
          userData.role ||
          userData.role_name ||
          userData.user_type ||
          userData.userRole ||
          ""
        ).toString();
        const tokenPayload = {
          role: role ? role.toLowerCase() : "hi",
          doctor: userData.doctor || "",
          logo: userData.clinic_icon || "",
          userId: userData.id || userData.user_id || userData.doctor_id,
          clinic_id: userData.clinic_id,
          ric: userData.ric || userData.role_in_clinic,
          doctor_id: userData.doctor_id || userData.id,
        };
        localStorage.setItem("tokenPayload", JSON.stringify(tokenPayload));
      } catch (e) {
        // ignore tokenPayload write errors
      }
      setUser(userData);
      return true;
    } catch (e) {
      console.error("Auth login error", e);
      return false;
    }
  };

  const logout = () => {
    localStorage.clear();
    setUser(null);
    navigate("/login", { replace: true });
  };

  const clearError = () => {
    // no-op for compatibility
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, clearError }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export default AuthContext;
